import { render, staticRenderFns } from "./PermisionRow.vue?vue&type=template&id=cc705522&scoped=true&"
import script from "./PermisionRow.vue?vue&type=script&lang=js&"
export * from "./PermisionRow.vue?vue&type=script&lang=js&"
import style0 from "./PermisionRow.vue?vue&type=style&index=0&id=cc705522&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc705522",
  null
  
)

export default component.exports